import { Component, Input, OnInit, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TRAVEL_SERVICES } from '../../constants/api-constants'
import { GlobalService } from '../../services/global/global.service';


@Component({
  selector: 'app-travel-service-input',
  templateUrl: './travel-service-input.component.html',
  styleUrls: ['./travel-service-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TravelServiceInputComponent),
      multi: true
    }
  ]
})
export class TravelServiceInputComponent implements OnInit, ControlValueAccessor {
  @Input() hideVisa: boolean = false;
  @Input() data: string[] | undefined;
  @Input() invalidInput: any;

  @Input() disableServiceType: boolean = false;

  TRAVEL_SERVICES = TRAVEL_SERVICES;
  role: any;
  visaUserLoggedIn: any;
  clientUserLoggedIn: any;
  hideVisaService: any;
  

  selectedItems: string[] = [];
  onChange: any = () => {};
  onTouched: any = () => {};

  constructor(
    private _globalService: GlobalService
  ) { }

  ngOnInit() {    
    this.role = localStorage.getItem("Role");

    if(this.role === "ClientVisa")
    {
      this.visaUserLoggedIn = true;
    }
    else
    {
      this.visaUserLoggedIn = false;
    }

    if(this.role === "ClientUser")
    {
       this.clientUserLoggedIn = true;
    }
    else
    {
      this.clientUserLoggedIn = false;
    }

    this._globalService.roles$.subscribe((roles) => {
      if (roles) {        
        const visaModule = roles.modules.find((module: any) => module.name === "Visas");
        if (!visaModule) {
          this.hideVisaService = true;
        }  
      }
    })

  }

  ngOnChanges(){    
  } 

  writeValue(value: any): void {
    if (value) {
      this.selectedItems = value;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    // Handle the disabled state if necessary
  }

  onCheckboxChange(event: any, item: string): void {
    // When Visa is selected, deselect all other services
    if (item === TRAVEL_SERVICES.VISA) {
      if (event.target.checked) {
        this.selectedItems = [TRAVEL_SERVICES.VISA];
      } else {
        this.selectedItems = [];
      }
    } else if (item === TRAVEL_SERVICES.TOUR_PACKAGE) {
      if (event.target.checked) {
        this.selectedItems = [TRAVEL_SERVICES.TOUR_PACKAGE, TRAVEL_SERVICES.TRANSPORTATION, TRAVEL_SERVICES.HOTELS, TRAVEL_SERVICES.SIGHTSEEING, TRAVEL_SERVICES.TRANSFERS];
      } else {
        this.selectedItems = [];
      }
    } else {
      // When any other service is selected, deselect Visa
      if (event.target.checked) {
        this.selectedItems = this.selectedItems.filter(i => i !== TRAVEL_SERVICES.VISA);
        this.selectedItems.push(item);
      } else {
        this.selectedItems = this.selectedItems.filter(i => i !== item);
      }
      
      // Ensure Tour Package is checked if all other services are checked (excluding Visa)
      const allServices = [
        TRAVEL_SERVICES.TRANSPORTATION, 
        TRAVEL_SERVICES.HOTELS, 
        TRAVEL_SERVICES.SIGHTSEEING, 
        TRAVEL_SERVICES.TRANSFERS
      ];
      if (allServices.every(service => this.selectedItems.includes(service))) {
        if (!this.selectedItems.includes(TRAVEL_SERVICES.TOUR_PACKAGE)) {
          this.selectedItems.push(TRAVEL_SERVICES.TOUR_PACKAGE);
        }
      }else{
        this.selectedItems = this.selectedItems.filter(i => i!== TRAVEL_SERVICES.TOUR_PACKAGE);
      }
    }
  
    this.onChange(this.selectedItems);
  }
  
  isChecked(item: string): boolean {
    return this.selectedItems.includes(item);
  }
  
}
